<template>
  <div
    v-if="!forceHideErrorBanner && showErrorBanner"
    class="relative flex w-full items-center justify-center bg-yellow-500 px-10 py-1.5 text-2xs text-white md:text-xs"
  >
    <p class="banner-alert-text mb-0">
      {{ errorBannerTitle }}
    </p>
    <div
      class="absolute right-1 flex h-6 w-6 cursor-pointer items-center justify-center p-1 md:right-4"
      @click="dismissBanner"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="10"
        height="11"
        viewBox="0 0 10 11"
        fill="none"
      >
        <path
          d="M1 9.5L9 1.5"
          stroke="white"
          stroke-width="2"
        />
        <path
          d="M1 1.5L9 9.5"
          stroke="white"
          stroke-width="2"
        />
      </svg>
    </div>
  </div>
  <slot />
</template>

<script>
export default {
  name: 'BannerAlert',
  computed: {
    showErrorBanner() {
      return this.$store.state.errors.showErrorBanner;
    },
    errorBannerTitle() {
      return this.$store.state.errors.errorBannerTitle;
    },
    forceHideErrorBanner() {
      return this.$store.state.errors.forceHideErrorBanner;
    },
  },
  watch: {
    '$store.state.onboardingPacket.current_stage': function (val, oldVal) {
      if (oldVal == 0 && val > 0) {
        this.$store.commit('errors/setForceHideErrorBanner', true);
      }
    },
  },
  methods: {
    dismissBanner() {
      this.$store.commit('errors/setShowErrorBanner', false);
    },
  },
};
</script>
